// extracted by mini-css-extract-plugin
module.exports = {"external-links":"ExternalLinks_external-links__FoEWZ"};